export default "/assets/images/performance-filter-img-03.e0daa856cb804606.png";